import {
  FilterOptionList,
  VisibleEnumSelect,
  VisibleDateRangeField,
  formatDateRangeDisplay,
  DateRangeControl,
  isDateRangeActive,
} from '@yeshuman/sdk'
import type { FilterDefinition, FilterOption } from '@yeshuman/sdk'
import { Activity as ActivityIcon, CalendarRange } from 'lucide-react'

import type { ActivityFilters } from '../hooks/use-activities'

export const ACTIVITY_TYPE_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
  { value: 'exercise', label: 'Exercise' },
  { value: 'sleep', label: 'Sleep' },
  { value: 'wellness', label: 'Wellness' },
]

export function getHealthActivityFilterDefinitions(): FilterDefinition<ActivityFilters, undefined>[] {
  return [
    {
      key: 'activity_type',
      label: 'Type',
      icon: ActivityIcon,
      displayValue: (filters) =>
        ACTIVITY_TYPE_OPTIONS.find((o) => o.value === filters.activity_type)?.label ?? 'All',
      isNonDefault: (filters) => Boolean(filters.activity_type),
      reset: (filters) => ({ ...filters, activity_type: undefined }),
      renderField: ({ filters, onChange }) => (
        <VisibleEnumSelect
          value={filters.activity_type ?? 'all'}
          options={ACTIVITY_TYPE_OPTIONS}
          onValueChange={(v) =>
            onChange({
              ...filters,
              activity_type: v === 'all' ? undefined : (v as ActivityFilters['activity_type']),
            })
          }
        />
      ),
      renderPopover: ({ filters, onChange }) => (
        <FilterOptionList
          type="single"
          options={ACTIVITY_TYPE_OPTIONS}
          value={filters.activity_type ?? 'all'}
          onValueChange={(v) =>
            onChange({
              ...filters,
              activity_type: v === 'all' ? undefined : (v as ActivityFilters['activity_type']),
            })
          }
        />
      ),
    },
    {
      key: 'date_range',
      label: 'Date range',
      icon: CalendarRange,
      displayValue: (filters) => formatDateRangeDisplay(filters, 'date'),
      isNonDefault: (filters) => isDateRangeActive(filters),
      reset: (filters) => ({ ...filters, start_date: undefined, end_date: undefined }),
      renderField: ({ filters, onChange }) => (
        <VisibleDateRangeField
          mode="date"
          value={filters}
          onChange={(range) => onChange({ ...filters, ...range })}
        />
      ),
      renderPopover: ({ filters, onChange }) => (
        <DateRangeControl
          mode="date"
          value={filters}
          onChange={(range) => onChange({ ...filters, ...range })}
        />
      ),
    },
  ]
}
